import React, { FunctionComponent } from "react";
import { NodeProps } from "reactflow";
import {
  BasicNodeLayout,
  DocumentSchemaSource,
  NodeSize,
  NodeType,
  NodeTypeCategory
} from "../../../components/NodeTypes/Base";
import { DataType, primitiveListTypes, primitiveTypes } from "../../../components/NodeTypes/TypeDefinitions";
import { NodeConfigPropertyType } from "../../FlowDocument/PropertyTypeDefinitions";

const inputName = "input";
const outputName = "result";

const schemaProperty = "schemaId";
const schemaNameProperty = "schemaName";

globalThis.nodeTypeDefinitions.setDefinition({
  nodeType: NodeType.coalesce,
  label: "Coalesce",
  category: NodeTypeCategory.transformations,
  controlOutputs: [],
  dataInputs: [{ name: inputName, hideLabel: true, type: DataType.STRING }],
  dataOutputs: [{ name: outputName, type: DataType.STRING }],
  size: NodeSize.Small,
  documentDataInputListName: "inputs",
  nodeConfigProperties: [
    {
      name: "schema",
      label: "Type",
      propertyType: NodeConfigPropertyType.DataType,
      clearPropertiesOnChange: [schemaProperty],
      options: {
        dataTypes: ([] as DataType[])
          .concat(primitiveTypes)
          .concat([DataType.OBJECT, DataType.OBJECTREFERENCE])
          .concat(primitiveListTypes)
          .concat([DataType.OBJECTLIST, DataType.OBJECTREFERENCELIST]),
        dataProperties: [inputName, outputName]
      },
      schemaSourceSystemType: DocumentSchemaSource.schemaPicker
    },
    {
      name: schemaProperty,
      label: "Object",
      propertyType: NodeConfigPropertyType.Schema,
      showOnPropertyValues: { propertyName: "schema", propertyValues: [DataType.OBJECT] },
      options: {
        changeSchemaOnConnection: true,
        excludeReferences: true,
        displayProperty: schemaNameProperty,
        dataProperties: [inputName, outputName]
      },
      schemaSourceSystemType: DocumentSchemaSource.schemaPicker
    },
    {
      name: schemaProperty,
      label: "Reference",
      propertyType: NodeConfigPropertyType.Schema,
      showOnPropertyValues: { propertyName: "schema", propertyValues: [DataType.OBJECTREFERENCE] },
      options: {
        changeSchemaOnConnection: true,
        referenceOnly: true,
        displayProperty: schemaNameProperty,
        dataProperties: [inputName, outputName]
      },
      schemaSourceSystemType: DocumentSchemaSource.schemaPicker
    },
    {
      name: schemaNameProperty,
      propertyType: NodeConfigPropertyType.NoInput
    },
    {
      name: "itemCount",
      label: "Items",
      propertyType: NodeConfigPropertyType.DataPropertyCount,
      options: { cloneFrom: inputName }
    }
  ],
  evaluate: (input: any) => {
    return { output: {}, activeControlHandleIds: [] };
  }
});

export const CoalesceNode: FunctionComponent<NodeProps> = ({ id, data }) => {
  return <BasicNodeLayout id={id} data={data} />;
};
